import { getCurrentGroup } from "$json/lib/getcurrentgroup.js";
import { getControl } from "$json/lib/control.js";
import { bb } from "$json";

const METADATA_ID = "p-mis-multi-click";
const END_TOOLS_DOCUMENT_ID = "end-tools-document";
const END_TOOLS_SELECTOR = ".bb-p-end-tools-container .download-container a";
const TRACKABLES = new Map();

function track(event) {
  if (event.target.tagName === "A") {
    const href = event.target.getAttribute("href");
    let id;
    // Simple case: tracking a href
    if (TRACKABLES.has(href)) {
      id = href;
    }
    // Track end-tools download doc
    else if (
      TRACKABLES.has(END_TOOLS_DOCUMENT_ID) &&
      event.target.matches(END_TOOLS_SELECTOR)
    ) {
      id = END_TOOLS_DOCUMENT_ID;
    } else {
      // Special case: tracking specific link element
      const control = getControl(event.target);
      if (!control) return;
      id = control.identifier.split(".").pop();
    }
    if (!id) return;
    const tracker = document.getElementById(TRACKABLES.get(id));
    if (tracker) {
      if (Number.isInteger(Number(tracker.value))) {
        tracker.value = 1 + Number(tracker.value);
      } else tracker.value = true;
      bb.updatemis();
    }
  }
}

document.body.addEventListener("click", track, { capture: true });

jQuery(document).on("bb:preHandleData", (_event, data) => {
  if (data && data.groups && data.groups.length) {
    TRACKABLES.clear();
    getCurrentGroup(data.groups).controls.forEach(control => {
      if (control.metadata && control.metadata[METADATA_ID]) {
        control.controltype = "hidden";
        TRACKABLES.set(control.metadata[METADATA_ID], control.id);
      }
    });
  }
});
